exports.byteLength = f793;
exports.toByteArray = f795;
exports.fromByteArray = f798;
var vA273 = [];
var vA274 = [];
var v4914 = typeof Uint8Array == "undefined" ? Array : Uint8Array;
var vLSABCDEFGHIJKLMNOPQRST2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var vLN0758 = 0, v4915 = vLSABCDEFGHIJKLMNOPQRST2.length; vLN0758 < v4915; ++vLN0758) {
  vA273[vLN0758] = vLSABCDEFGHIJKLMNOPQRST2[vLN0758];
  vA274[vLSABCDEFGHIJKLMNOPQRST2.charCodeAt(vLN0758)] = vLN0758;
}
vA274["-".charCodeAt(0)] = 62;
vA274["_".charCodeAt(0)] = 63;
function f792(p5906) {
  var v4916 = p5906.length;
  if (v4916 % 4 > 0) {
    throw new Error("Invalid string. Length must be a multiple of 4");
  }
  var v4917 = p5906.indexOf("=");
  if (v4917 === -1) {
    v4917 = v4916;
  }
  var v4918 = v4917 === v4916 ? 0 : 4 - v4917 % 4;
  return [v4917, v4918];
}
function f793(p5907) {
  var vF792 = f792(p5907);
  var v4919 = vF792[0];
  var v4920 = vF792[1];
  return (v4919 + v4920) * 3 / 4 - v4920;
}
function f794(p5908, p5909, p5910) {
  return (p5909 + p5910) * 3 / 4 - p5910;
}
function f795(p5911) {
  var v4921;
  var v4922;
  var vF7922 = f792(p5911);
  var v4923 = vF7922[0];
  var v4924 = vF7922[1];
  var v4925 = new v4914(f794(p5911, v4923, v4924));
  var vLN0759 = 0;
  var v4926 = v4924 > 0 ? v4923 - 4 : v4923;
  for (v4922 = 0; v4922 < v4926; v4922 += 4) {
    v4921 = vA274[p5911.charCodeAt(v4922)] << 18 | vA274[p5911.charCodeAt(v4922 + 1)] << 12 | vA274[p5911.charCodeAt(v4922 + 2)] << 6 | vA274[p5911.charCodeAt(v4922 + 3)];
    v4925[vLN0759++] = v4921 >> 16 & 255;
    v4925[vLN0759++] = v4921 >> 8 & 255;
    v4925[vLN0759++] = v4921 & 255;
  }
  if (v4924 === 2) {
    v4921 = vA274[p5911.charCodeAt(v4922)] << 2 | vA274[p5911.charCodeAt(v4922 + 1)] >> 4;
    v4925[vLN0759++] = v4921 & 255;
  }
  if (v4924 === 1) {
    v4921 = vA274[p5911.charCodeAt(v4922)] << 10 | vA274[p5911.charCodeAt(v4922 + 1)] << 4 | vA274[p5911.charCodeAt(v4922 + 2)] >> 2;
    v4925[vLN0759++] = v4921 >> 8 & 255;
    v4925[vLN0759++] = v4921 & 255;
  }
  return v4925;
}
function f796(p5912) {
  return vA273[p5912 >> 18 & 63] + vA273[p5912 >> 12 & 63] + vA273[p5912 >> 6 & 63] + vA273[p5912 & 63];
}
function f797(p5913, p5914, p5915) {
  var v4927;
  var vA275 = [];
  for (var vP5914 = p5914; vP5914 < p5915; vP5914 += 3) {
    v4927 = (p5913[vP5914] << 16 & 16711680) + (p5913[vP5914 + 1] << 8 & 65280) + (p5913[vP5914 + 2] & 255);
    vA275.push(f796(v4927));
  }
  return vA275.join("");
}
function f798(p5916) {
  var v4928;
  var v4929 = p5916.length;
  var v4930 = v4929 % 3;
  var vA276 = [];
  for (var vLN16383 = 16383, vLN0760 = 0, v4931 = v4929 - v4930; vLN0760 < v4931; vLN0760 += vLN16383) {
    vA276.push(f797(p5916, vLN0760, vLN0760 + vLN16383 > v4931 ? v4931 : vLN0760 + vLN16383));
  }
  if (v4930 === 1) {
    v4928 = p5916[v4929 - 1];
    vA276.push(vA273[v4928 >> 2] + vA273[v4928 << 4 & 63] + "==");
  } else if (v4930 === 2) {
    v4928 = (p5916[v4929 - 2] << 8) + p5916[v4929 - 1];
    vA276.push(vA273[v4928 >> 10] + vA273[v4928 >> 4 & 63] + vA273[v4928 << 2 & 63] + "=");
  }
  return vA276.join("");
}